const { produce } = require("immer");

const init = {
  uid: null,
  serviceUid: null,
  name: null,
  endpoints: []
}

module.exports = function (state = init, action) {
  switch(action.type) {
    case "SET_apiForm":
      return produce(state, draft => {
        Object.assign(draft, init, action.form);
        if(action.form.service) draft.serviceUid = action.form.service;
      });

    case "UPDATE_apiForm":
      return produce(state, draft => {
        Object.assign(draft, action.form);
      });

    case "RESET_apiForm":
      return init;

    default:
      return state;
  }
}
